import { IconWarningCircle } from "@suse-o11y/icons";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import React, { type FC } from "react";
import { useSelector } from "react-redux";

import { selectTimestampDate } from "../../app/state/view/timeline/TimelineSelectors";
import { DocLink } from "../../components/react/docLink/DocLink";
import { LinkFrom } from "../../components/react/link";

export const SnapshotIndication: FC = () => {
	const timestamp = useSelector(selectTimestampDate);

	if (!timestamp) {
		return null;
	}

	return (
		<div
			className="flex w-64 shrink-0 items-stretch gap-x-1 self-stretch text-13"
			data-testid="snapshot-indication"
			data-tourid="snapshot-indication"
		>
			<TooltipBoundary>
				<TooltipTrigger className="flex items-center gap-x-2 text-yellow-500">
					<IconWarningCircle className="text-base" />
					You are in time travel mode.
				</TooltipTrigger>

				<Tooltip className="tooltip/tooltip">
					The timeline is currently paused. Whilst traveling back in time is useful when doing an investigation, it also
					means you are not seeing any live data. <DocLink capture="noop" slug="ui-topology-time" text="Learn more" />
				</Tooltip>
			</TooltipBoundary>

			<TooltipBoundary>
				<TooltipTrigger asChild>
					<LinkFrom
						className="flex items-center font-medium text-grey-100 underline hover:no-underline"
						from="*"
						search={(search) => ({ ...search, timestamp: undefined })}
					>
						Go live
					</LinkFrom>
				</TooltipTrigger>

				<Tooltip className="tooltip/tooltip">Show changes in real-time</Tooltip>
			</TooltipBoundary>
		</div>
	);
};
